import { createFileRoute } from '@tanstack/react-router';

import Loading from '@/_pages/agreements/api-integration/loading';
import { getAgreementQueryOptions } from '@/_pages/agreements/api-service';

export const Route = createFileRoute('/_private/agreements/_template/$id/api-integration')({
  loader: (opts) => opts.context.queryClient.ensureQueryData(getAgreementQueryOptions(opts.params.id)),
  staticData: {
    pageTitle: 'API Integrations',
    tabKey: 'agreement/api-integration',
  },
  pendingComponent: Loading,
});
